<div *ngIf="checkoutProcessView">
    <fuse-card class="flex flex-col p-4">

        <div class="flex flex-row">

            <div class="flex flex-col w-full">

                <div class="flex flex-row">
                    <div class="flex w-10 h-10 justify-center items-center bg-primary-200 rounded-full mr-2 md:mr-8">
                        <mat-icon svgIcon="heroicons_solid:banknotes" [color]="'primary'"></mat-icon>
                    </div>
                    <div class="flex flex-row font-bold text-black text-2xl">
                        Upfront payment
                    </div>
                </div>

                <hr class="my-5">
            </div>
        </div>
        <div class="flex flex-row w-full font-extrabold text-black text-2xl pb-8">
            Upfront payment required
        </div>
        <div class="flex flex-row w-full">
            <div class="flex flex-col text-black">
                To activate your service, an upfront payment is required.
                You can either do the upfront payment now, or later, however your service will not be activated until payment is made.
            </div>
        </div>

        <div class="flex flex-row justify-center items-center md:justify-start">

            <button
                class="mt-4  font-bold bg-accent self-start "
                mat-flat-button
                [color]="'accent'"
                (click)="payNow()"
                >
                Pay {{upFrontAmount | currency:'R'}} now
            </button>
        </div>
    </fuse-card>
</div>

<div *ngIf="!checkoutProcessView"> 
    <div class="flex flex-row w-full text-lg font-bold">
        Upfront payment required
    </div>
    <div class="flex flex-row w-full">
        <div class="flex flex-col text-black">
            To activate your service, an upfront payment is required.
            You can either do the upfront payment now, or later, however your service will not be activated until payment is made.
        </div>
    </div>

    <div class="flex flex-row">

        <button
            class="mt-8 font-bold bg-accent self-start"
            mat-flat-button
            [color]="'accent'"
            (click)="payNow()"
            >
            Pay {{upFrontAmount | currency:'R'}} now
        </button>
    </div>
</div>